module.exports = __webpack_public_path__ + "img/right_grey_arrow_dark.6390c3fa.svg";